<template lang="pug">
  .Home
    swiper
    introduce
    architecture
    products
    solutions
    package-set
    information
    partner
    cooperative
</template>

<script>
  import '../index.styl';
  import Swiper from "@/views/Home/swiper/index";
  import Introduce from "@/views/Home/introduce/index";
  import Architecture from "@/views/Home/architecture/index";
  import Products from "@/views/Home/products/index";
  import Solutions from "@/views/Home/solutions/index";
  import PackageSet from "@/views/Home/packageSet/packageSet";
  import Information from "@/views/Home/information/information";
  import Partner from "@/views/Home/partner/partner";
  import Cooperative from "@/views/Home/cooperative/cooperative";
  
  export default {
    name: "Home",
    components: {Cooperative, Partner, Information, PackageSet, Solutions, Products, Architecture, Introduce, Swiper},
  };
</script>

<style scoped lang="stylus">
  @import "../../assets/css/colors.styl"
  @import "../index.styl"
  .Home {
    display flex
    flex-direction column
    align-items center
    justify-content flex-start
    background-color #ffffff
    min-width 1392px
    position relative
    @media (max-width ipadProScreenWidth) {
      max-width ipadProScreenWidth
      min-width 0
      width 100vw
      overflow hidden
    }
    @media (max-width screenWidth) {
      min-width 0
      width 100vw
      overflow hidden
    }
  }
</style>
